import { render } from "./DepositPage.vue?vue&type=template&id=468a350f&scoped=true"
import script from "./DepositPage.vue?vue&type=script&lang=js"
export * from "./DepositPage.vue?vue&type=script&lang=js"

import "./DepositPage.vue?vue&type=style&index=0&id=468a350f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468a350f"]])

export default __exports__